<template>
    <div>
        <v-card flat>
            <DialogoPreOpNivel v-if="showDialogoNivel" ref="opcNivel" :width="width" @nivelSelected="nivelActual" />
            <ValidationObserver ref="obs" v-slot="{ invalid }">
                <v-form name="FormPreNivel" @submit.prevent="guardar">
                    <v-row class="mx-1">
                        <v-col :class="($vuetify.breakpoint.mobile) ? 'my-2' : 'my-3'">
                            <div
                                class="d-flex flex justify-start font-weight-bold text-body-1 black--text text-uppercase">
                                Opción de nivel
                            </div>
                            <div class="font-weight-regular text-body-1 mt-3">
                                {{ infoNivel }}
                            </div>
                            <v-col cols="12" md="12" class="px-0">
                                <v-alert v-if="aporteReducido" type="orange" class="rounded-0 mt-5" dense
                                    icon="mdi-information" color="orange darken-2">
                                    Podés optar por el beneficio de aportación reducida<b>
                                        {{ itemReduce[0].text_completo }}
                                    </b>
                                </v-alert>
                            </v-col>
                            <ValidationProvider rules="required" v-slot="v">
                                <v-select ref="select" v-model="dataSelected.nivel" outlined
                                    :items="(!dataSelected.reducido) ? itemNivel : itemReduce" :item-text="item => !dataSelected.reducido
                                        ? (beneficioDiscapacidad
                                            ? `NIVEL ${item.nivel} (${item.cantMod * 0.75} Módulos)`
                                            : `NIVEL ${item.nivel} (${item.cantMod} Módulos)`)
                                        : `${item.text_completo}`" item-value="nivel" class="mt-5"
                                    :error-messages="v.errors[0]" :menu-props="customMenuProps" @click="goToNiveles"
                                    label="Seleccioná una opción de nivel" />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-divider class="ma-5"></v-divider>
                    <v-row v-if="dataSelected.nivel == 1" class="mx-1">
                        <v-card-title class="font-weight-bold text-body-1 black--text text-uppercase ">
                            Información laboral
                        </v-card-title>
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required|max:10|nofechafutura" v-slot="v">
                                <v-text-field v-model="dataSelected.empleoDesde" dense
                                    label="Fecha de inicio de actividad:" type="date" @change="evaluarNivel"
                                    :error-messages="v.errors[0]"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required|max:50" v-slot="v">
                                <v-text-field dense v-model="dataSelected.empleo"
                                    @input="dataSelected.empleo = dataSelected.empleo.toUpperCase()"
                                    :error-messages="v.errors[0]" type="text" label="Empleador">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required|max:50" v-slot="v">
                                <v-text-field dense v-model="dataSelected.empleoTipo" :error-messages="v.errors[0]"
                                    type="text" label="Tipo de Empleo"
                                    @input="dataSelected.empleoTipo = dataSelected.empleoTipo.toUpperCase()">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <div v-if="dataSelected.nivel == 1">
                        <v-row class="mx-1">
                            <v-col>
                                <AlertaNiveles />
                            </v-col>
                        </v-row>
                        <v-row class="mx-1">
                            <v-col :class="($vuetify.breakpoint.mobile) ? 'my-2' : 'my-3'">
                                <div
                                    class="d-flex flex justify-start font-weight-bold text-body-1 black--text text-uppercase">
                                    Documentación requerida:
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="d-flex justify-space-around align-end">
                            <InputButtonArchivo op="reciboSueldo" label="RECIBO DE SUELDO"
                                @fileSelected="handleFileSelected" />
                            <InputButtonArchivo op="certLaboral" @fileSelected="handleFileSelected"
                                label="CERT. LABORAL" />
                        </v-row>
                        <v-col cols="12" md="12" class="mt-5 mx-1">
                            <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                <v-checkbox dense v-model="confirmarNivel" :error-messages="v.errors[0]">
                                    <template v-slot:label>
                                        <div
                                            :class="(confirmarNivel) ? `font-weight-regular primary--text` : `font-weight-regular dark--text`">
                                            {{ label }} .
                                        </div>
                                    </template>
                                </v-checkbox>
                            </ValidationProvider>
                        </v-col>
                    </div>
                    <v-row v-if="(dataSelected.nivel !== 1)" class="mx-1 mb-5">
                        <v-col cols="12" md="12">
                            <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                <v-checkbox dense v-model="confirmarNivel" :error-messages="v.errors[0]">
                                    <template v-slot:label>
                                        <div
                                            :class="(confirmarNivel) ? `font-weight-regular primary--text` : `font-weight-regular dark--text`">
                                            Confirmo que deseo solicitar nivel {{
                                                (dataSelected.reducido) ? itemReduce[0].text_completo : dataSelected.nivel
                                            }}
                                        </div>
                                    </template>
                                </v-checkbox>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <div class="d-flex justify-space-between mt-5 form-footer" @click="forzarValidacion">
                        <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                        </v-btn>
                        <v-btn v-if="dataSelected.nivel == 1" color="primary" elevation="0"
                            :disabled="invalid || !formValid" type="submit" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                        <v-btn v-else color="primary" elevation="0" :disabled="invalid" type="submit" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </div>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>

<script>

import DialogoPreOpNivel from '@/components/dialogos/DialogoPreOpNivel.vue'
import AlertaNiveles from '@/components/alerts/AlertaNiveles.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import AlertaLaboral from '@/components/cards/Laboral.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        AlertaNiveles,
        AlertaLaboral,
        ValidationObserver,
        ValidationProvider,
        DialogoPreOpNivel,
        InputButtonArchivo,
    },
    data() {
        return {
            loading: false,
            titulo: '',
            tipo: '',
            width: '',
            icon: '',
            obj: false,
            dataSelected:
            {
                tipoAporte: '',
                //nueva tipoAporte: '', 
                reducido: 0,
                nivel: '',
                esJubilado: 0,
                empleo: '',
                empleoTipo: '',
                empleoDesde: '',
            },

            //para ocultar el menu en el select de opcion de nivel
            customMenuProps: {
                openOnClick: false,
            },
            files: '',
            files1: '',

            formValid: false,
            infoNivel: "La opción de nivel le permite al afiliado o afiliada determinar el monto a percibir de jubilación en función de lo que elija abonar mensualmente. Existen dos ocasiones para hacerlo. La primera es al inicio de su vida profesional y luego, anualmente durante los meses de octubre y noviembre. El nivel elegido durante ésos meses tendrá vigencia para el año calendario siguiente.",

            label: 'Dejo expresa constancia que tengo pleno conocimiento que al optar por realizar mis aportes en el Nivel 1 (aportación reducida),percibiré una jubilación reducida que resultará complementaria a la que recibiré por mi trabajo en relación de dependencia aquí declarado, y por el cual me encuentro aportando en otro regimen previsional (art. 41, 42, 70 y 72 Ley 12.163 y modif. y reglamentaciones vigentes)',
            confirmacion: '',
            confirmarNivel: false,
            confirmation: false,
            itemVista: [],
            showDialogoNivel: false,
        }
    },
    watch: {
        'dataSelected.nivel'(newValue) {
            if ((newValue == 2) && (this.dataSelected.reducido)) this.dataSelected.tipoAporte = (this.itemReduce[0].text == 'PMJ') ? 1 : 2
        },
        'aporteReducido'(newValue) {
            if (newValue) {
                this.dataSelected.nivel = 2
                this.dataSelected.reducido = 1
                this.dataSelected.tipoAporte = (this.itemReduce[0].text == 'PMJ') ? 1 : 2
            }
        }
    },

    methods: {
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('preafiliacion', ['guardarDatosNivel', 'addFilesPre', 'defaultItemReduce', 'generateVistaData', 'evaluarNivel1']),
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        evaluarNivel() {
            this.evaluarNivel1({
                empleoDesde: this.dataSelected.empleoDesde,
                fecmat: this.datosProfesionales.fecmat,
            }).then((result) => {
                if (!result) this.dataSelected.nivel = ""
            })
        },
        volver() {
            this.defaultItemReduce()
            this.$emit('atras')
        },
        handleFileSelected() {
            if (this.dataSelected.nivel == 1)
                (this.reciboSueldo.length !== 0) ? this.formValid = true : this.formValid = false
        },

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                const [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },

        goToNiveles() {
            this.$refs.select.blur()
            this.width = "980"
            this.type = 'nivel'
            if (!this.showDialogoNivel) {
                this.showDialogoNivel = true;
                this.$nextTick(() => {
                    if (this.$refs.opcNivel && this.$refs.opcNivel.abrirDialogo) {
                        if (this.aporteReducido) {
                            this.$refs.opcNivel.selectedBtn = 6
                        }
                        this.$refs.opcNivel.abrirDialogo().then(() => {
                            this.showDialogoNivel = false;
                        });
                    }
                });
            }
        },
        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },
        nivelActual(value) {
            this.addFilesPre({ file: '', op: 'reciboSueldo' })
            this.addFilesPre({ file: '', op: 'certLaboral' })
            if (value < 6) {
                this.dataSelected.nivel = value
                this.dataSelected.reducido = 0
                this.dataSelected.empleo = ''
                this.dataSelected.empleoTipo = ''
                this.dataSelected.empleoDesde = ''
            } else {
                this.dataSelected.nivel = 2
                this.dataSelected.reducido = 1
                this.dataSelected.tipoAporte = (this.itemReduce[0].text == 'PMJ') ? 1 : 2
            }
            this.confirmarNivel = false
        },
        guardar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.guardarDatosNivel(this.dataSelected)
                    this.$emit('siguiente')
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
        },

        isObject(value) {
            return (
                typeof value == 'object' &&
                value !== null &&
                !Array.isArray(value)
            )
        },
    },
    computed: {
        ...mapGetters('preafiliacion', ['datosContacto', 'aporteReducido', 'datosNivel', 'reciboSueldo', 'certLaboral', 'tipoAporteRed', 'desTipoAporteRed', 'itemReduce', 'datosPersonales', 'datosProfesionales']),
        ...mapGetters('common', ['itemNivel']),

        beneficioDiscapacidad() {
            return (this.datosPersonales.tramita_discapacidad == 'S') && !(this.aporteReducido)
        }
    },
    props: ['index']
}
</script>

<style>
/* Aplicamos el estilo para ajustar el tamaño del texto */
.v-list-item__subtitle {
    white-space: normal;
}
</style>